<template>
  <div class="login-page">
    <div class="page-title">
      欢迎绑定沙箱账号
    </div>
    <div class="page-content">
      <div class="login-type-box">
        <div :class="['login-type-item', {'active': byPwd}]" @click="changeLoginType(0)">密码绑定</div>
        <div :class="['login-type-item', {'active': byCode}]" @click="changeLoginType(1)">验证码绑定</div>
      </div>
      <div class="from-box large-form" v-show="this.byPwd">
        <el-form ref="loginForm1"
                 :model="editInfo"
                 label-width="0">
          <el-form-item label="" prop="account" :rules="rules.account">
            <el-input v-model.trim="editInfo.account" maxlength="50" clearable placeholder="用户名/邮箱">
              <i slot="prefix" class="input-icon input-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="captcha_code" :rules="rules.code" class="input-code-item">
            <el-input v-model="editInfo.captcha_code" maxlength="4" clearable placeholder="图片验证码">
              <i slot="prefix" class="input-icon input-icon-shield"></i>
            </el-input>
            <div class="input-code-box">
              <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
            </div>
          </el-form-item>
          <input type="password" class="hide-input">
          <el-form-item label="" prop="password" :rules="rules.password">
            <el-input v-model="editInfo.password" type="password" maxlength="16" clearable placeholder="请输入密码"
                      autocomplete="new-password">
              <i slot="prefix" class="input-icon input-icon-password"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="submit-btn" @click="bindByPwd">登录并绑定</el-button>
      </div>
      <div class="from-box large-form" v-show="this.byCode">
        <el-form ref="loginForm2"
                 :model="editInfo"
                 label-width="0">
          <input type="password" class="hide-input">
          <el-form-item label="" prop="reg_mobile" :rules="rules.reg_mobile">
            <el-input v-model="editInfo.reg_mobile" maxlength="11" clearable placeholder="请输入手机号">
              <i slot="prefix" class="input-icon input-icon-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="captcha_code" :rules="rules.code" class="input-code-item">
            <el-input v-model="editInfo.captcha_code" maxlength="4" clearable placeholder="图片验证码">
              <i slot="prefix" class="input-icon input-icon-shield"></i>
            </el-input>
            <div class="input-code-box">
              <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
            </div>
          </el-form-item>
          <el-form-item label="" prop="sms_code" :rules="rules.code" class="input-code-item">
            <el-input v-model="editInfo.sms_code" maxlength="4" clearable placeholder="请输入验证码">
              <i slot="prefix" class="input-icon input-icon-password"></i>
            </el-input>
            <div class="input-code-box text-warning pointer" @click="getSmsCode">
              {{ smsTimer === 0 ? '获取验证码' : `${smsTimer}s后重试` }}
            </div>
          </el-form-item>
        </el-form>
        <el-button class="submit-btn" @click="bindByCode">登录并绑定</el-button>
      </div>
      <div style="width: 100%; text-align: center; margin-top: 5px">注：沙箱环境账号只需绑定一次
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import md5 from 'md5'
import {sandboxRequest} from "../../axios/sandboxRequest";
import Vue from "vue";

export default {
  name: 'bind',
  props: ['showSwitch'],
  data() {
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    }
    let passwordCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value && !this.$config.regCommon.password.test(value)) {
        callback(new Error('密码长度为8~16位，需包含数字和字母，字母区分大小写'));
      } else {
        callback();
      }
    }
    return {
      bindType: 0,
      codeImg: '',
      codeKey: '',
      smsTimer: 0,
      dataList: [{name: '沙箱', number: 1}, {name: '正式', number: 0}],
      editInfo: {
        account: '',
        password: '',
        reg_mobile: '',
        captcha_code: '',
        sms_code: '',
      },
      rules: {
        account: [
          {required: true, message: '请输入用户名/邮箱', trigger: 'blur'}
        ],
        reg_mobile: [
          {validator: phoneCheck, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        password: [
          {validator: passwordCheck, trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    this.sandbox = 1;
    if (!this.hasLogin) {
      Vue.prototype.$message.error('请先登录');
      window.location.href = '/#/log-in';
    }
    let loginType = Number(localStorage.getItem('loginType'))
    if (loginType === 0 || loginType === 1) {
      this.changeLoginType(loginType)
    }

  },
  computed: {
    byPwd() {
      return this.bindType === 0;
    },
    byCode() {
      return this.bindType === 1;
    },
  },
  methods: {
    ...mapActions(['getUserInfo']),
    changeLoginType(type) {
      this.bindType = type
      if (this.byPwd) {
        this.$refs.loginForm2 && this.$refs.loginForm2.clearValidate()
      }
      if (!this.codeImg) {
        this.getImgCode()
      }
      this.$refs.loginForm1 && this.$refs.loginForm1.clearValidate()
    },
    // 获取图片验证码
    getImgCode() {
      this.$axios.get("/ajax/common/interface/captcha/get", {
        params: {
          type: 2 // 1为注册; 2为登陆; 3为忘记密码
        }
      }).then(res => {
        this.codeImg = res.data.data.img
        this.codeKey = res.data.data.key
      })
    },
    // 验证图片验证码
    checkImgCode() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/ajax/common/interface/captcha/check", {
          code: this.editInfo.captcha_code,
          key: this.codeKey,
          type: 2
        }).then(res => {
          resolve();
        }).catch(e => {
          if (e.type === 1) {
            this.getImgCode();
            reject()
          } else if (e.type === 2) {
            reject()
          }
        });
      })
    },
    // 获取短信验证码
    getSmsCode() {
      if (this.isLoading || this.smsTimer !== 0) {
        return
      }
      let checkNum = 0;
      let checkError = '';
      this.$refs.loginForm2.validateField(['reg_mobile', 'captcha_code'], error => {
        checkNum++;
        checkError += error;
        if (checkNum === 2 && !checkError) {
          this.showCommonLoading();
          this.$axios.post("/ajax/common/interface/mobile/code", {
            reg_mobile: this.editInfo.reg_mobile,
            code: this.editInfo.captcha_code,
            key: this.codeKey,
            type: 2
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.$message.success('短信验证码发送成功');
              this.setSmsTimer();
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    },
    // 设置短信验证码获取倒计时
    setSmsTimer() {
      this.smsTimer = 60;
      let timerItem = setInterval(() => {
        if (this.smsTimer === 0) {
          clearInterval(timerItem)
        } else {
          this.smsTimer--
        }
      }, 1000)
    },
    bindByPwd() {
      this.$refs.loginForm1.validate(valid => {
        if (valid) {
          this.applyLogin()
        }
      })
    },

    bindByCode() {
      let checkNum = 0;
      let checkError = '';
      this.$refs.loginForm2.validateField(['reg_mobile', 'sms_code'], error => {
        checkNum++;
        checkError += error;
        if (checkNum === 2 && !checkError) {
          this.applyLogin()
        }
      })
    },

    applyLogin() {
      if (this.isLoading) {
        return
      }
      this.showCommonLoading()
      if (this.byPwd) {
        let params = {
          account: this.editInfo.account,
          password: md5(this.editInfo.password),
          code: this.editInfo.captcha_code,
          key: this.codeKey
        }
        sandboxRequest.bindByPwd(params).then(res => success(res)).catch((e) => failure(e));
      } else {
        let params = {
          reg_mobile: this.editInfo.reg_mobile,
          sms_code: this.editInfo.sms_code,
          code: this.editInfo.captcha_code,
          key: this.codeKey
        }
        sandboxRequest.bindByCode(params).then(res => success(res)).catch(e => failure(e));
      }
      let success = (res) => {

        console.log(res);

        this.hideCommonLoading();
        if (res.ret === 0) {
          let data = res.data;
          localStorage.setItem('token', data.access_token)
          localStorage.setItem('sandboxToken', data.sandbox_access_token)
          localStorage.setItem('expiresIn', data.expires_in)
          this.getUserInfo();
          this.$router.push({path: '/control/myapp'});
        } else {
          failure(res.msg);
        }
      }
      let failure = (msg) => {
        this.getImgCode();
        this.hideCommonLoading();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  width: 550px;
  margin: 55px auto;

  .page-title {
    width: 100%;
    height: 34px;
    line-height: 32px;
    font-size: 24px;
    color: #212121;
    text-align: center;
    margin: 24px 0;
  }

  .title-sub {
    position: absolute;
    right: 6px;
    top: 8px;
    font-size: 12px;
    color: #ccc;
  }

  .page-content {
    width: 100%;
    margin-top: 55px;
    padding-bottom: 88px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .login-type-box {
    width: 100%;
    height: 80px;
    overflow: hidden;
    border-bottom: 1px solid #E5E5E5;
  }

  .login-type-item {
    width: 50%;
    height: 32px;
    line-height: 32px;
    color: #9E9E9E;
    font-size: 20px;
    text-align: center;
    margin-top: 24px;
    box-sizing: border-box;
    cursor: pointer;
    float: left;

    &.active {
      color: #F16222;
    }

    &:first-child {
      border-right: 2px solid #E5E5E5;
    }
  }

  .from-box {
    width: 430px;
    margin: 50px auto 0;
  }

  .submit-btn {
    width: 100%;
    height: 48px;
    background: #F16222;
    font-size: 18px;
    color: #fff;
    border: none;
    font-weight: normal;

    &.disabled {
      background: rgba(241, 98, 34, .35);
    }
  }

  .forget-box {
    margin-top: 15px;
    padding-left: 5px;
    font-size: 12px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/bind.vue